
export default class FormItemDateTimeDisplay
{
    static getDisplayText(value)
    {
        return value;
    }

    static getDisplayText2(value,displayFormat)
    {
        if(!value)return value;
		let date = new Date(value);
		return FormItemDateTimeDisplay.dateFormat2(displayFormat,date);//date.format(displayFormat);
	}
	
	static dateFormat2(fmt,date)
	{
		var o = {
			"M+": date.getMonth() + 1, //月份 
			"D+": date.getDate(), //日 
			"H+": date.getHours(), //小时 
			"N+": date.getMinutes(), //分 
			"S+": date.getSeconds() //秒 
		};
		if (/(Y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
		for (var k in o)
		if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		return fmt;
	}
}


// WEBPACK FOOTER //
// ./src/formItem/display/FormItemDateTimeDisplay.js